import jquery from 'jquery';
import 'jquery.transit';
import 'jquery-easing';
import 'es6-promise/auto';

window.$ = jquery;
window.jQuery = jquery;

import owd from 'owd/owd';
import 'app/components/img-load';
import 'app/components/form';
import 'app/components/slider';
import 'app/components/scroll-top';
import 'app/components/menu-toggle';
import 'app/components/nav-toggle';
import 'app/components/inview';
import 'app/components/skip-link';
import 'app/components/infographic';
import 'app/components/accordion';
import 'app/components/dictionary';
import 'app/components/tabs';
import 'app/components/slide';
import 'app/components/inject-charts';
import 'app/components/chart-line';
import 'app/components/files';
import 'app/components/trigger-search';
import 'app/components/search';
import 'app/components/font-size';
import 'app/components/contrast';
import 'app/components/main-menu';
import 'app/components/tooltip';
import 'app/components/print';
import 'app/components/back';
import 'app/components/fixed-header';
import 'app/components/modal';
import 'app/components/gdpr';
// import 'app/components/fullpage-section';
// import 'app/components/fullpage-container';

import DefaultResolver from 'app/ajax/default-resolver';
import CategoriesResolver from 'app/ajax/categories-resolver';

import Ajax from 'owd/module/ajax';
import BrowserIE from 'owd/module/browser-ie';
// import FullPage from 'owd/module/fullpage';
// import ScrollbarPlaceholder from 'owd/module/scrollbar-placeholder';

const app = new owd.App();

// app.use('scrollbarPlaceholder', ScrollbarPlaceholder);
// app.use('fullpage', FullPage);
app.use('ajax', Ajax)
    .registerDefaultResolver(DefaultResolver)
    .registerResolver('categories', CategoriesResolver);


app.use('browser-ie', BrowserIE);

app.run();
